// extracted by mini-css-extract-plugin
module.exports = {"serialCodeInput":"SerialCodeInput_serialCodeInput__vAr0d"};